import { render, staticRenderFns } from "./StagingDisclaimer.vue?vue&type=template&id=3803b33a&scoped=true"
import script from "./StagingDisclaimer.vue?vue&type=script&lang=js"
export * from "./StagingDisclaimer.vue?vue&type=script&lang=js"
import style0 from "./StagingDisclaimer.vue?vue&type=style&index=0&id=3803b33a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803b33a",
  null
  
)

export default component.exports